import { FeatureFlag, FeatureName } from 'Hooks/Api/apiFeatureFlag';
import { useApiFeatureFlags } from 'Hooks/ApiHooks/useApp';
import React, { createContext, ReactNode, useContext } from 'react';

type ApplicationContextType = {
	featureFlags: FeatureFlag[];
	isFeatureEnabled: (value: FeatureName) => boolean
};

const defaultContext: ApplicationContextType = {
	featureFlags: [],
	isFeatureEnabled: (_value: FeatureName) => false
};

const ApplicationContext = createContext<ApplicationContextType>(defaultContext);

type ApplicationProviderProps = {
	children: ReactNode;
};

export const ApplicationProvider: React.FC<ApplicationProviderProps> = ({ children }) => {

	// 1. Fetch any data required for app
	const reqFeatureFlags = useApiFeatureFlags();

	const featureFlags = reqFeatureFlags.data ?? [];

	// Helper functions to work against the data
	const isFeatureEnabled = (value: FeatureName) => {
		return !!featureFlags.find(x => x.name === value && x.isEnabled === true);
	}

	// Construct the context from various response data
	const ctx: ApplicationContextType = {
		isFeatureEnabled: isFeatureEnabled,
		featureFlags: featureFlags,
	}

	return (
		<ApplicationContext.Provider value={ctx}>
			{children}
		</ApplicationContext.Provider>
	);
};

export const useApplicationContext = () => useContext(ApplicationContext);